/**
 * Get the API base URL that works for both local development and mobile device access
 * 
 * When accessing from a phone on the same network, the phone needs to use the computer's 
 * IP address instead of "localhost". This function automatically detects the appropriate URL.
 * 
 * - If accessed via localhost: uses localhost
 * - If accessed via IP (e.g., 192.168.1.55): uses that IP
 * - Automatically replaces localhost in env variables with current hostname
 */
export const getApiBaseUrl = () => {
  const host = window.location.hostname; // localhost or 192.168.1.55
  const protocol = window.location.protocol; // http: or https:
  
  // First, check if there's an environment variable set
  if (process.env.REACT_APP_API_BASE_URL) {
    const envUrl = process.env.REACT_APP_API_BASE_URL;
    
    // If env URL contains localhost or 127.0.0.1, replace with current hostname
    // This allows mobile devices to work when accessing via IP address
    if (envUrl.includes('localhost') || envUrl.includes('127.0.0.1')) {
      // Replace localhost/127.0.0.1 with actual hostname (works for both localhost and IP)
      return envUrl.replace(/localhost|127\.0\.0\.1/g, host);
    }
    
    // If env URL already has a specific host, use it as-is
    return envUrl;
  }

  // Fallback: Construct URL from current hostname
  // Default port is 8080, but can be overridden with REACT_APP_API_PORT
  const port = process.env.REACT_APP_API_PORT || '8080';
  const apiPath = '/api'; // Default API path
  
  return `${protocol}//${host}:${port}${apiPath}`;
};

export const API_BASE = getApiBaseUrl();

